import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
/**
 * Note: Example of modified JSON5 file is found on the individual docs
 * due to limitations in how these kinds of reusable components work.
 **/
const styles = {};

function CommIntroductionEnd() {
    return (
        <React.Fragment>
            <p>
                <strong>Note</strong>: Do not modify the <code className="language-text">deviceId</code> included in the
                configuration file.
            </p>
            <ol start="3">
                <li>Save and close the file.</li>
                <br />
                <li>
                    Restart the communication service:
                    <br />
                    <br />
                    <br />
                    <strong>Linux</strong>: <code className="language-text">sudo siginit restart sigmsg</code>
                </li>
                <br />
                <strong>Windows</strong>: Restart the Signiant Communication Service from the <strong>Services</strong>{' '}
                control panel.
                <br />
            </ol>

            <p>
                After collecting the required logs, revert the file to the previous version, or change the logging level
                to <code className="language-text">info</code>, and restart Signiant services.
            </p>
        </React.Fragment>
    );
}

CommIntroductionEnd.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CommIntroductionEnd);
